import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { WhySection } from './components/WhySection';
import { Subscription } from './components/Subscription';
import { Gifting } from './components/Gifting';
import { About } from './components/About';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream selection:bg-sand selection:text-charcoal" data-id="element-0">
      <Navigation data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <HowItWorks data-id="element-4" />
        <WhySection data-id="element-5" />
        <Subscription data-id="element-6" />
        <Gifting data-id="element-7" />
        <About data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}